import {
    EDIT_TEMP_COMP_OFF_REQUEST,
    EDIT_TEMP_COMP_OFF_SUCCESS,
    EDIT_TEMP_COMP_OFF_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const editTempCompOffByAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_TEMP_COMP_OFF_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case EDIT_TEMP_COMP_OFF_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case EDIT_TEMP_COMP_OFF_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default editTempCompOffByAdminReducer;
